app.controller("UploadSyllabusController", ["$scope", "$uibModalInstance", "SyllabusParser",
    function ($scope, $uibModalInstance, SyllabusParser) {

        $scope.create = function () {
            $uibModalInstance.close(SyllabusParser.parseSyllabus($scope.syllabus));
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
